module.exports = __webpack_public_path__ + "static/media/skip_website.3e39a63f.svg";